export default {"src":"/_next/static/media/magic_exchange.0ed78c3e.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};